export const URL_FLAGS = {
    SKIP_VALIDATION_BLOCK: 'skip-validation-block',
} as const;
